import React, { useState, useEffect } from "react";
import "./style.scss";
import classNames from "classnames";
import PropTypes from "prop-types";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import ContactSupportSubmitted from "../../sections/contact-support-submitted";
import ContactSupportForm from "../../sections/contact-support-form";
import SuggestedArticles from "../../sections/suggested-articles";
import api from "../../utils/api";

const ContactSupportDecember = ({ rendering, fields, lang }) => {
  const {
    paddingAboveBottom,
    paddingAboveTop,
    backgroundColor,
    backgroundImage,
    captcha,
    countryTip,
    subjectTip,
    emailTipText,
    messageTipText,
    messageRequiredError,
    emailErrorTipText,
    emailRequiredError,
    countryRequiredError,
    subjectRequiredError,
    firstnameLabel,
    firstnameRequired,
    lastnameLabel,
    lastnameRequired,
    defaultError,
    consent,
    disclaimer,
    CtaName,
    iconName,
    colorScheme,
    headingBody,
    headingType,
    body,
    submittedheadingBody,
    submittedHeadingType,
    submittedBody,
    image,
    suggestedArticles = {}
  } = fields;

  const [isSubmitted, setIsSubmitted] = useState();
  const [submitting, setSubmitting] = useState(false);
  const [hasError, setHasError] = useState();
  const [serverErrorMessage, setServerErrorMessage] = useState();
  const [countries, setCountries] = useState();
  const [countryVisible, setCountryVisible] = useState();
  const [subjects, setSubjects] = useState();
  // const [subjectVisible, setSubjectVisible] = useState();

  useEffect(() => {
    let language = lang;
    api.subjecttype
      .get({
        language: language
      })
      .then(res => {
        const subjects = res.map(e => {
          return {
            value: e.displayName,
            code: e.code
          };
        });
        setSubjects(subjects);
        // setSubjectVisible(true);
      });

    if (language.search("-") === -1) {
      api.country
        .list(null, {
          language: language
        })
        .then(
          /**
           *@param {CountryListRes} res
           * */
          res => {
            const countries = res.obj.regions.map(e => {
              return {
                id: e.regionId,
                value: e.regionName,
                code: e.regionNo
              };
            });
            // this.documentChange(model);

            setCountries(countries);
          }
        )
        .catch(res => {});
      setCountryVisible(true);
    } else {
      language = language.split("-")[0];
      setCountryVisible(false);
    }
  }, []);

  const bindConsent = async (email, country, siteRes) => {
    let _lang = lang.toLowerCase();
    //const siteRes = await api.site.get({ key: lang });
    const countryId = _lang === "en" ? (country ? country.id : null) : siteRes.CountryLocal;
    const consentNo = consent ? consent.id : "";

    const headers = {
      language: siteRes.CountryLang,
      organization: siteRes.CountryOrg,
      lang: _lang
    };
    const body = {
      isSubscriptionFlag: "0",
      receiver: email,
      contentMap: {},
      email: email,
      countryId: countryId,
      consentCode: consentNo
    };
    setSubmitting(true);
    const bindRes = await api.bind(null, body, {
      headers: headers
    });
    if (bindRes.code === "CONSENT_EXCEPTION_016") {
      // this.setState({
      //   emailEnteredShowError: true,
      //   emailWarningMessage: emailErrorTipText.value
      // });
      return bindRes.code;
      // throw new Error(bindRes.msg,bindRes.code);
    } else if (bindRes.code !== "1" && bindRes.code !== "CUSTOMER_SUBSCRIPTION_005") {
      throw new Error(bindRes.msg, bindRes.code);
    }
  };

  const onSubmit = async data => {
    //event && event.preventDefault();

    if (!submitting && data) {
      try {
        let _lang = lang.toLowerCase();
        setSubmitting(true);
        const siteRes = await api.site.get({ key: _lang });
        const bindconsent = await bindConsent(data.email, data.country, siteRes);

        if (bindconsent === "CONSENT_EXCEPTION_016") {
          return false;
        }

        const body = {
          contactInfo: {
            email: data.email,
            country: _lang === "en" ? (data.country ? data.country.id : null) : siteRes.CountryLocal,
            preferLanguage: siteRes.CountryleadsLang
          },
          caseInfo: {
            subject: data.subject,
            title: data.title || "",
            description: data.message
          },
          clientCode: "0"
        };
        api
          .contact(null, body)
          .then(res => {
            switch (res.status) {
              case 200:
                console.log("success");
                setIsSubmitted(true);
                window.location.hash = `${this.props.page.itemId};submitted`;
                break;
              default:
                setHasError(true);
                setServerErrorMessage(defaultError ? defaultError.value : res.msg);
                break;
            }
          })
          .catch(res => {
            setHasError(true);
            setServerErrorMessage(defaultError ? defaultError.value : res.Message);
          })
          .finally(() => {
            setSubmitting(false);
          });
      } catch (e) {
        setHasError(true);
        setServerErrorMessage(defaultError ? defaultError.value : e.message);
      }
    }
  };

  const contactSupportClasses = classNames(`padding-bottom-${paddingAboveBottom.fields.key.value}`, `padding-top-${paddingAboveTop.fields.key.value}`, "contact-support", "grid"),
    titleClasses = "title";

  let backgroundStyle = backgroundColor.fields.key.value
    ? {
        background: backgroundColor.fields.key.value
      }
    : {};

  if (isSubmitted && backgroundImage.value.src) {
    backgroundStyle = {
      background: `linear-gradient(180deg, rgba(0, 0, 0, 0.12) 0%, rgba(0, 0, 0, 0.95) 100%), url(${backgroundImage.value.src})`
    };
  }

  return (
    <div className={contactSupportClasses} style={backgroundStyle} datasourceid={rendering.dataSource}>
      <div className="left">
        {!isSubmitted && (
          <React.Fragment>
            {/* header */}
            {headingBody.value && <Heading html={headingBody} type={headingType} className={titleClasses} typographyClass="type-h1" />}
            <BodyText html={body.value} />
            <ContactSupportForm
              {...{
                firstnameLabel,
                firstnameRequired,
                lastnameLabel,
                lastnameRequired,
                hasCaptcha: captcha.value,
                countryTip,
                subjectTip,
                emailTipText,
                emailErrorTipText,
                emailRequiredError,
                countryRequiredError,
                subjectRequiredError,
                messageRequiredError,
                subject: { options: subjects },
                countries: { options: countries },
                countryVisible,
                messageTipText,
                disclaimer,
                hasError,
                errorMessage: serverErrorMessage,
                button: {
                  colorScheme: colorScheme,
                  iconName: iconName,
                  link: {
                    value: {
                      text: CtaName.value
                    }
                  },
                  isDisabled: {
                    value: consent ? false : true
                  }
                },
                onSubmitForm: data => onSubmit(data)
              }}
            />
          </React.Fragment>
        )}

        {isSubmitted && (
          <ContactSupportSubmitted
            {...{
              submittedheadingBody,
              submittedHeadingType,
              submittedBody,
              image
            }}
          />
        )}
      </div>
      {suggestedArticles && <SuggestedArticles {...suggestedArticles} className="right" />}
    </div>
  );
};

ContactSupportDecember.propTypes = {
  rendering: PropTypes.shape({ dataSource: PropTypes.string }),
  fields: PropTypes.shape({
    paddingAboveBottom: PropTypes.object,
    paddingAboveTop: PropTypes.object,
    backgroundColor: PropTypes.object,
    backgroundImage: PropTypes.object,
    captcha: PropTypes.object,
    countryTip: PropTypes.object,
    subjectTip: PropTypes.object,
    emailTipText: PropTypes.object,
    messageTipText: PropTypes.object,
    messageRequiredError: PropTypes.object,
    emailErrorTipText: PropTypes.object,
    emailRequiredError: PropTypes.object,
    countryRequiredError: PropTypes.object,
    subjectRequiredError: PropTypes.object,
    firstnameLabel: PropTypes.object,
    firstnameRequired: PropTypes.object,
    lastnameLabel: PropTypes.object,
    lastnameRequired: PropTypes.object,
    defaultError: PropTypes.object,
    consent: PropTypes.object,
    disclaimer: PropTypes.object,
    CtaName: PropTypes.object,
    iconName: PropTypes.object,
    colorScheme: PropTypes.object,
    headingBody: PropTypes.object,
    headingType: PropTypes.object,
    body: PropTypes.object,
    submittedheadingBody: PropTypes.object,
    submittedHeadingType: PropTypes.object,
    submittedBody: PropTypes.object,
    image: PropTypes.object,
    suggestedArticles: PropTypes.object
  })
};

export default ContactSupportDecember;
